import { render, staticRenderFns } from "./Terzisti.vue?vue&type=template&id=2432656c&"
import script from "./Terzisti.vue?vue&type=script&lang=js&"
export * from "./Terzisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports